'use client';

import { c as _c } from "react/compiler-runtime";
import { useGetDrawResult } from '@svs/nova-poolbetting/core/frameworks/nextjs/draw';
import type { DrawNumber } from '@svs/nova-poolbetting/schema/draw';
import type { Definition } from '@svs/nova-poolbetting/schema/frameworks';
import type { EventNumber } from '@svs/nova-poolbetting/schema/sport';
import { type CouponOutcomePredictionBaseProps, CouponOutcomeWrapper } from '@svs/nova-poolbetting/ui/Coupon';
import type { ReactNode } from 'react';
type CouponEventOutcomeProps = CouponOutcomePredictionBaseProps & {
  eventNumber: EventNumber;
  product: Definition['drawProducts'][number];
  drawNumber: DrawNumber;
};

/**
 * Coupon event outcome component wrapped for client usage.
 *
 * @param root0 props for CouponEventOutcomeClientContainer
 * @param root0.eventNumber event number for the coupon event
 * @param root0.product product for the draw result
 * @param root0.drawNumber draw number for the draw result
 * @returns Coupon event outcome component wrapped for client usage
 */
export function CouponEventOutcomeClientContainer(t0) {
  const $ = _c(12);
  let drawNumber;
  let eventNumber;
  let product;
  let props;
  if ($[0] !== t0) {
    ({
      eventNumber,
      product,
      drawNumber,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = drawNumber;
    $[2] = eventNumber;
    $[3] = product;
    $[4] = props;
  } else {
    drawNumber = $[1];
    eventNumber = $[2];
    product = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== drawNumber || $[6] !== product) {
    t1 = {
      product,
      drawNumber
    };
    $[5] = drawNumber;
    $[6] = product;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const drawResult = useGetDrawResult(t1);
  let correctOutcome = undefined;
  if (drawResult.data.type !== "NONE") {
    const currentEventResult = drawResult.data.data.drawResults[eventNumber - 1];
    if (currentEventResult) {
      correctOutcome = currentEventResult.outcome[0];
    }
  }
  let t2;
  if ($[8] !== correctOutcome || $[9] !== eventNumber || $[10] !== props) {
    t2 = <CouponOutcomeWrapper eventNumber={eventNumber} outcomeStatus="correct" correctOutcome={correctOutcome} {...props} />;
    $[8] = correctOutcome;
    $[9] = eventNumber;
    $[10] = props;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}